import getMinDate from './getMinDate';
import getMaxDate from './getMaxDate';
import { isEqual } from 'date-fns';

function daySkipped(config) {
  if (config.skipDay) {
    return true;
  }

  const minDate = getMinDate(config);
  const maxDate = getMaxDate(config);

  let sameDay = false;
  if (minDate != null && maxDate != null) {
    sameDay = isEqual(minDate, maxDate);
  }

  return sameDay;
}

export default daySkipped;
